import * as client from '../../services/client';
import {
  TYPES,
  PATHS,
  SuccessMessages,
  ErrorMessages,
} from 'src/common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  stopPRLoading,
  startPRLoading,
  startFormLoading,
  stopFormLoading,
} from './loader';
import { setValidation } from './validation';
import { selectAuthenticatedUser } from '../selectors/auth';
import { store } from '..';
import { setItemFormData } from './itemForm';
import { ToastSuccess, ToastFail } from 'src/helpers/validationHelper';

const fetchPropertiesDone = (payload) => ({
  type: TYPES.FETCH_PROPERTIES_DONE,
  payload,
});

export const fetchProperties = (userId, role, loader, type) => (dispatch) => {
  if (loader === false) {
  } else {
    dispatch(startPRLoading());
  }
  return client
    .getProperties(userId, role)
    .then((response) => {
      dispatch(stopPRLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            dispatch(fetchPropertiesDone(responsejson.data));
            if (type === 'add') {
              dispatch(
                setItemFormData({
                  selectedProperties:
                    responsejson.data && responsejson.data.length > 0
                      ? responsejson.data.map((pty) => ({
                          value: pty.id,
                          label: pty.name,
                        }))
                      : [],
                  isSelectAll: true,
                })
              );
            }
            dispatch(stopPRLoading());
          } else {
            dispatch(stopPRLoading());
          }
        });
      } else {
        // dispatch(stopLoading())
      }
    })
    .catch(() => {
      dispatch(stopPRLoading());
    });
};

export const fetchPropertyByIdDone = (payload) => ({
  type: TYPES.FETCH_PROPERTY_BY_ID_DONE,
  payload,
});

export const fetchPropertyById = (id) => (dispatch) => {
  return client.getPropertyById(id).then((response) => {
    if (response.status === '200' || response.ok) {
      response.json().then((responsejson) => {
        dispatch(fetchPropertyByIdDone(responsejson));
      });
    }
  });
};

const savePropertyDone = (payload) => ({
  type: TYPES.SAVE_PROPERTY_DONE,
  payload,
});

export const saveProperty = (property) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .saveProperty(property)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          dispatch(setValidation('Success'));
          if (responsejson.data && responsejson.data.length > 0) {
            dispatch(savePropertyDone(responsejson.data[0]));
            ToastSuccess(SuccessMessages.propertyAdded);
          } else {
            ToastFail(ErrorMessages.propertyAddError);
          }
        });
      } else {
        ToastFail(ErrorMessages.propertyAddError);
      }
    })
    .catch(() => {
      dispatch(stopFormLoading());
      ToastFail(ErrorMessages.propertyAddError);
    });
};

const deletePropertyDone = (payload) => ({
  type: TYPES.DELETE_PROPERTY_DONE,
  payload,
});

export const deleteProperty = (id, userId, history) => (dispatch) => {
  dispatch(startFormLoading());
  return client.deleteProperty(id, userId).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {});
      toast.success('ⓘ Property has been deleted.', {
        autoClose: 10000,
        position: 'top-center',
      });
      if (history) {
        history.push(PATHS.PROPERTIES_LIST);
      }
      dispatch(deletePropertyDone(id));
    } else {
      response.json().then((responsejson) => {});
      toast.error(
        ' 🚫 Something went wrong with deleting the property, please try again.',
        {
          autoClose: 12000,
          position: 'top-center',
        }
      );
    }
  });
};

const updatePropertyDone = (payload) => ({
  type: TYPES.UPDATE_PROPERTY_DONE,
  payload,
});

export const updateProperty = (data, history) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .updateProperty(data)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          dispatch(setValidation('Success'));
          if (responsejson.data && responsejson.data.length > 0) {
            dispatch(updatePropertyDone(responsejson.data[0]));
            toast.success(' ⓘ Property details have been updated.', {
              autoClose: 10000,
              position: 'top-center',
            });
          } else {
            toast.error(
              ' 🚫 Something went wrong with updating a property, please try again.',
              {
                autoClose: 12000,
                position: 'top-center',
              }
            );
          }
          if (history) {
            history.push(PATHS.PROPERTIES_LIST);
          }
        });
      } else {
        toast.error(
          ' 🚫 Something went wrong with updating a property, please try again.',
          {
            autoClose: 12000,
            position: 'top-center',
          }
        );
      }
    })
    .catch(() => {
      toast.error('🚫 Something Went Wrong Please try again.', {
        autoClose: 12000,
        position: 'top-center',
      });
    });
};

const fetchPropertyCommonAreasDone = (payload) => ({
  type: TYPES.FETCH_PROPERTY_COMMON_AREAS_DONE,
  payload,
});

const fetchPropertyCommonAreasForFilterDone = (payload) => ({
  type: TYPES.FETCH_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE,
  payload,
});

export const selectPropertyCommonAreasForFilterDone = (payload) => ({
  type: TYPES.SELECTION_OF_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE,
  payload,
});

export const clearSelectedPropertyCommonAreas = () => ({
  type: TYPES.CLEAR_SELECTED_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE,
});
export const fetchPropertyCommonAreas = (propertyId, loader) => (dispatch) => {
  dispatch(startPRLoading());
  client.fetchPropertyCommonAreas(propertyId).then((response) => {
    if (response.ok || response.status) {
      response.json().then((responsejson) => {
        dispatch(fetchPropertyCommonAreasForFilterDone(responsejson.data));
        dispatch(fetchPropertyCommonAreasDone(responsejson.data));
        dispatch(stopPRLoading());
      });
    }
  });
};

export const savePropertyCommonAreas = (data) => (dispatch) => {
  return client.savePropertyCommonAreas(data).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        toast.success('  ⓘ Common Areas Configured Successfully.', {
          autoClose: 10000,
          position: 'top-center',
        });
        dispatch(fetchPropertyCommonAreas(responsejson.data.propertyId));
        let user = selectAuthenticatedUser(store.getState());
        dispatch(
          fetchPropertyCounts(
            responsejson.data.propertyId,
            user.id,
            user.roles[0].role.name
          )
        );
      });
    }
  });
};

export const fetchCountsDone = (payload) => ({
  type: TYPES.FETCH_COUNTS_DONE,
  payload,
});

export const clearCountsDone = () => ({
  type: TYPES.CLEAR_COUNTS_DONE,
});

export const fetchPropertyCounts = (propertyId, userId, role) => (dispatch) => {
  return client
    .fetchPropertyCounts(propertyId, userId, role)
    .then((response) => {
      if (response.status === 200 || response.ok) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            dispatch(fetchCountsDone(responsejson.data));
          }
        });
      }
    });
};
